import React from 'react'

import { COLORS, CloudinaryImage, Footnote } from 'ethos-design-system'

import { FormattedDate } from '../global/FormattedDate'
import styles from './Byline.module.scss'

interface HeaderBylineProps {
  authorName?: string
  date?: Date
  link?: string
  image?: string
  imageAlt?: string
  color?: keyof typeof COLORS
}

interface PreviewBylineProps {
  authorName?: string
  date?: Date
  link?: string
  showLearnMore?: boolean
  learnMoreLink?: string
}

type BylineProps = Pick<HeaderBylineProps, 'authorName' | 'date' | 'color'>

export function HeaderByline({
  authorName,
  date,
  link,
  image,
  imageAlt,
  color = COLORS.GRAY_SECONDARY,
}: HeaderBylineProps) {
  const displayDot = authorName && date
  const altText = imageAlt || 'Ethos Media'
  if (link && authorName) {
    return (
      <Footnote.Regular400 color={color}>
        <div className={styles.bylineGroup}>
          {image && (
            <CloudinaryImage
              publicId={image}
              alt={altText}
              className={styles.image}
            />
          )}
          {image && <span> </span>}
          <a href={link}>{authorName && authorName}</a>
          {displayDot && <span> | </span>}
          {date && <FormattedDate date={date} />}
        </div>
      </Footnote.Regular400>
    )
  } else {
    return Byline({ authorName, date, color })
  }
}

export function PreviewByline({
  authorName,
  date,
  link,
  showLearnMore,
  learnMoreLink,
}: PreviewBylineProps) {
  if (showLearnMore) {
    return (
      <Footnote.Medium500 color={COLORS.BRAND_FOREST}>
        <div className={styles.previewBylineGroup}>
          <a href={learnMoreLink}>{'Learn more →'}</a>
        </div>
      </Footnote.Medium500>
    )
  } else if (link && authorName) {
    return (
      <Footnote.Regular400 color={COLORS.GRAY_SECONDARY}>
        <div className={styles.previewBylineGroup}>
          <a href={link}>{authorName && authorName}</a>
          {date && <FormattedDate date={date} />}
        </div>
      </Footnote.Regular400>
    )
  } else if (date) {
    return (
      <Footnote.Regular400 color={COLORS.GRAY_SECONDARY}>
        <div className={styles.previewBylineGroup}>
          <div>{authorName && authorName}</div>
          {date && <FormattedDate date={date} />}
        </div>
      </Footnote.Regular400>
    )
  }

  return null
}

export function Byline({
  authorName,
  date,
  color = COLORS.GRAY_SECONDARY,
}: BylineProps) {
  const displayDot = authorName && date
  return (
    <Footnote.Regular400 color={color}>
      {authorName && authorName}
      {displayDot && <span> | </span>}
      {date && <FormattedDate date={date} />}
    </Footnote.Regular400>
  )
}
